const getInitValue = (numberInputs, rowindex, columnindex) => {
  if (rowindex !== null && columnindex !== null) {
    return numberInputs?.[rowindex]?.[columnindex];
  } else return 0;
};

export default getInitValue;
